// extracted by mini-css-extract-plugin
export default {"status-card":"uploading_status-card__tar66","status-card-message-wrapper":"uploading_status-card-message-wrapper__qHoBU"};